import {
  IKpiData,
  IPlannedVsActualPoint,
  IScheduleGapRow,
  IScheduleDeptRow,
} from '../hrAnalytics.types'

export const MOCK_SCHEDULE_KPIS: IKpiData[] = [
  {
    value: '4,440',
    label: 'PLANNED',
    sublabel: 'Shift assignments in range',
    accentColor: '#30B6D1',
    iconKey: 'calendar',
  },
  {
    value: '4,063',
    label: 'ACTUAL',
    sublabel: 'Finalized attendance records',
    accentColor: '#00B04C',
    iconKey: 'checkCircle',
  },
  {
    value: '79.3%',
    label: 'COVERAGE',
    accentColor: '#ff9900',
    iconKey: 'warning',
  },
]

export const MOCK_PLANNED_VS_ACTUAL: IPlannedVsActualPoint[] = Array.from(
  { length: 30 },
  (_, i) => ({
    date: `Jan ${i + 1}`,
    planned: 130 + Math.floor(Math.random() * 40),
    actual: 110 + Math.floor(Math.random() * 40),
  })
)

export const MOCK_COVERAGE_GAPS: IScheduleGapRow[] = [
  { date: 'Jan 23', planned: 169, actual: 119, gap: 50, coverage: 94.3 },
  { date: 'Jan 22', planned: 152, actual: 120, gap: 32, coverage: 93.1 },
  { date: 'Jan 29', planned: 149, actual: 125, gap: 24, coverage: 93.1 },
  { date: 'Jan 19', planned: 148, actual: 130, gap: 18, coverage: 91.4 },
  { date: 'Jan 20', planned: 142, actual: 131, gap: 11, coverage: 91.4 },
  { date: 'Jan 27', planned: 140, actual: 135, gap: 5, coverage: 90 },
  { date: 'Jan 21', planned: 139, actual: 136, gap: 3, coverage: 90 },
  { date: 'Jan 30', planned: 138, actual: 136, gap: 2, coverage: 70 },
  { date: 'Jan 28', planned: 128, actual: 127, gap: 1, coverage: 89.4 },
  { date: 'Jan 26', planned: 128, actual: 127, gap: 1, coverage: 89.4 },
]

export const MOCK_SCHEDULE_BY_DEPT: IScheduleDeptRow[] = [
  { name: 'HSE & Safety', planned: 210, actual: 198, gap: 8, coverage: 94.3 },
  { name: 'Maintenance', planned: 980, actual: 912, gap: 48, coverage: 93.1 },
  { name: 'Mining Operations', planned: 2100, actual: 1920, gap: 128, coverage: 91.4 },
  { name: 'Processing Plant', planned: 650, actual: 585, gap: 42, coverage: 90 },
  { name: 'Administration', planned: 180, actual: 162, gap: 12, coverage: 90 },
  { name: 'Fleet & Transport', planned: 320, actual: 286, gap: 22, coverage: 89.4 },
]

export const MOCK_SCHEDULE_BY_ROLE: IScheduleDeptRow[] = [
  { name: 'Operators', planned: 1200, actual: 1110, gap: 60, coverage: 92.5 },
  { name: 'Technicians', planned: 800, actual: 740, gap: 38, coverage: 92.5 },
  { name: 'Supervisors', planned: 300, actual: 282, gap: 12, coverage: 94.0 },
  { name: 'Engineers', planned: 200, actual: 186, gap: 8, coverage: 93.0 },
  { name: 'Drivers', planned: 400, actual: 360, gap: 28, coverage: 90.0 },
  { name: 'Admin Staff', planned: 150, actual: 138, gap: 8, coverage: 92.0 },
]
